import { render, staticRenderFns } from "./add-document.vue?vue&type=template&id=42aa7a95&scoped=true"
import script from "./add-document.vue?vue&type=script&lang=js"
export * from "./add-document.vue?vue&type=script&lang=js"
import style0 from "./add-document.vue?vue&type=style&index=0&id=42aa7a95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa7a95",
  null
  
)

export default component.exports